export default __webpack_public_path__ + "static/media/money-cof.047677ba.png";